import React from 'react';
import Footer from '../components/Footer';
import Nav from '../components/Nav';

const About = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Nav />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 sm:py-20 flex-1">
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-normal mb-6 sm:mb-8 leading-tight"
          style={{ fontFamily: 'Instrument Serif, serif' }}
        >
          Built by someone who lived this problem
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-base sm:text-lg lg:text-xl text-[#1a1a1a]/80 leading-relaxed mb-5 sm:mb-6">
            Verilock was built by a SaaS professional with 5 years of experience across cybersecurity, HR tech, and fintech. After watching hundreds of early-stage founders lose deals because they couldn't answer a simple compliance question, we decided to fix it.
          </p>

          <p className="text-base sm:text-lg lg:text-xl text-[#1a1a1a]/80 leading-relaxed">
            Not with a $30,000 audit process. With a 40-second AI-powered tool that gives every founder what they need to walk into any deal with confidence.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
